// extracted by mini-css-extract-plugin
module.exports = {"container":"BillLayout_container__tF3W0","logo":"BillLayout_logo__-BMu5"};